/**
 * SkillDelivery Platform
 * PreviewShell — layout wrapper for the public invite welcome page.
 *
 * Mirrors the authenticated app's two-column shell (sidebar + main)
 * but is self-contained (no auth context, no react-router). The real
 * authenticated Layout stays untouched per the Phase 1a golden rule.
 *
 * Responsive: sidebar collapses on screens <= 900px.
 */
import React, { useEffect, useState } from 'react';
import BrandSidebar from './BrandSidebar';

/**
 * @param {object} props
 * @param {object} props.brand           { logo_url, color, source, initials }
 * @param {string} props.organisation    Customer organisation for sidebar + top strip
 * @param {string} [props.ownerName]
 * @param {function(sectionId:string):void} [props.onNavigate]
 * @param {React.ReactNode} props.topStrip
 * @param {React.ReactNode} props.children
 */
export default function PreviewShell({ brand, organisation, ownerName, onNavigate, topStrip, children }) {
  const [wide, setWide] = useState(_isWide());
  useEffect(() => {
    const onResize = () => setWide(_isWide());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc' }}>
      {topStrip && (
        <div style={{
          padding: '8px 20px',
          background: '#0f172a',
          color: 'white',
          fontSize: 13,
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 10
        }}>
          {topStrip}
        </div>
      )}

      <div style={{ display: 'flex', alignItems: 'stretch' }}>
        {wide && (
          <BrandSidebar
            organisation={organisation}
            brand={brand}
            onNavigate={onNavigate}
          />
        )}
        <main style={{
          flex: 1,
          minWidth: 0,
          padding: wide ? '32px 40px' : '20px 16px'
        }}>
          {children}
        </main>
      </div>
    </div>
  );
}

function _isWide() {
  if (typeof window === 'undefined') return true;
  return window.innerWidth > 900;
}
